<div class="skf-checkbox">
  <mat-checkbox
    [name]="name"
    [checked]="checked"
    (change)="doChange($event)"
    [indeterminate]="indeterminate"
    [labelPosition]="labelPosition"
    [formControl]="formControl">{{label}}</mat-checkbox>
</div>
